import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/404.svg'


const _withScopeId = n => (_pushScopeId("data-v-da20da4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-not-found-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-not-found__img-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Page not found",
      class: "page-not-found__img"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h1", { class: "page-not-found__heading" }, " Looks like you’ve treaded off the beaten path ")
], -1))

import Header from '@/components/Header.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PageNotFound',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _hoisted_1
  ], 64))
}
}

})